__turbopack_context__.v({
  "cardAside": "CardAside-module__b35vdG__cardAside",
  "cardAsideNavigationControl": "CardAside-module__b35vdG__cardAsideNavigationControl",
});
